import { FC } from "react";
import { ChoiceChip } from "shared/components/Spor";

type TrainBadgesProps = {
  trainIds: string[];
};

export const TrainBadges: FC<TrainBadgesProps> = ({ trainIds }) => (
  <>
    {trainIds.map((it) => (
      <ChoiceChip
        key={it}
        size="xs"
        chipType="choice"
        checked
        style={{ pointerEvents: "auto" }}
      >
        {it}
      </ChoiceChip>
    ))}
  </>
);
